import React from 'react';
import './PipelineToggleSwitch.css';

export interface PipelineToggleSwitchProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  label?: string;
  disabled?: boolean;
  className?: string;
}

const PipelineToggleSwitch: React.FC<PipelineToggleSwitchProps> = ({
  checked,
  onChange,
  label,
  disabled,
  className = '',
}) => (
  <label
    className={`pipeline-switch${disabled ? ' pipeline-switch--disabled' : ''}${className ? ` ${className}` : ''}`}
  >
    <input
      type="checkbox"
      checked={checked}
      disabled={disabled}
      onChange={(e) => onChange(e.target.checked)}
    />
    <span className="pipeline-switch__track" aria-hidden="true" />
    {label ? <span className="pipeline-switch__label">{label}</span> : null}
  </label>
);

export default PipelineToggleSwitch;
